export const stepWithMood = [
  {
    percent: 0,
    id: 'TEAM MOOD',
    name: 'Team Mood',
  },
  {
    percent: 20,
    id: 'THINK',
    name: 'Think',
  },
  {
    percent: 40,
    id: 'GROUP',
    name: 'Group',
  },
  {
    percent: 60,
    id: 'VOTE',
    name: 'Vote',
  },
  {
    percent: 80,
    id: 'DISCUSS',
    name: 'Discuss',
  },
  {
    percent: 100,
    id: 'SUMMARY',
    name: 'Summary',
  },
];

export const normalStep = [
  {
    percent: 0,
    id: 'THINK',
    name: 'Think',
  },
  {
    percent: 25,
    id: 'GROUP',
    name: 'Group',
  },
  {
    percent: 50,
    id: 'VOTE',
    name: 'Vote',
  },
  {
    percent: 75,
    id: 'DISCUSS',
    name: 'Discuss',
  },
  {
    percent: 100,
    id: 'SUMMARY',
    name: 'Summary',
  },
];
